import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import { API_ENDPOINTS, DEFAULT_PAGE_START } from '../Utils/constants'
import { generateFormData } from '../Utils/helpers'

export default class ResellerHomeStore extends FetchBase {
  @observable countryWiseProjects = []
  @observable countryWiseProjectsLoader = false
  @observable countryWiseProjectsTotal = 0
  @observable countryNameForProjects = undefined
  @observable currentCountryData = undefined
  @observable currentSelecteCountry = undefined

  @observable topOrgListData = []
  @observable totalTopOrg = 0
  @observable topOrgLoader = true
  @observable topOrgFilters = {}

  @observable ordering = undefined
  @observable orderingBy = undefined

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingBy = (value = undefined) => {
    this.orderingBy = value
  }

  @action.bound
  setTopOrgFilter = (values = {}) => {
    this.topOrgFilters = values
  }

  @action.bound
  generateLineItemFilters = () => {
    let tempgenerateLineItemFilters = {}

    let keys = Object.keys(this.topOrgFilters || {})
    for (let filter of keys) {
      if (this.topOrgFilters[filter] !== undefined) {
        tempgenerateLineItemFilters[filter] = this.topOrgFilters[filter]
      }
    }
    this.ordering &&
      (tempgenerateLineItemFilters['orgOrdering'] = this.ordering)
    this.ordering &&
      (tempgenerateLineItemFilters['orgOrderBy'] = this.orderingBy)
    return tempgenerateLineItemFilters
  }

  @action.bound
  topOrgList = async (signal) => {
    try {
      this.topOrgLoader = true
      let options = this.generateLineItemFilters() || {}
      // options['pageLimit'] = '0'
      let response = await this.post(
        API_ENDPOINTS.TOP_ORG_WIDGET_RESELLER,
        {
          ...options,
        },
        signal
      )
      if (response.status) {
        this.topOrgListData = response.data
        this.totalTopOrg = response.data.length
        return true
      }
      this.topOrgListData = []

      return false
    } catch (err) {
      this.topOrgListData = []

      return false
    } finally {
      this.topOrgLoader = false
    }
  }

  @action.bound
  setCountryNameByClicked = (values = undefined, countryGeoData = []) => {
    this.countryNameForProjects = values?.name || undefined
    values && (values['sortName'] = values?.id)
    values && (values['stateListLow'] = countryGeoData[0] || undefined)
    values && (values['stateListHigh'] = countryGeoData[1] || undefined)
    delete values?.madeFromGeoData
    this.currentCountryData = values || undefined
  }

  @action.bound
  setCountryNameForProjects = (name = undefined, values = undefined) => {
    this.countryNameForProjects = name || undefined
    this.currentSelecteCountry = name || undefined

    values && (values['sortName'] = values?.name)
    values && (values['name'] = values?.value)
    delete values?.children
    delete values?.value
    this.currentCountryData = values || undefined
  }

  @action.bound
  getCountryWiseProjects = async (signal) => {
    try {
      this.countryWiseProjectsLoader = true
      let filters = this.getCountryWiseProjectsFilters() || {}
      let response = await this.get(
        API_ENDPOINTS.COUNTRY_WIDGET_RESELLER,
        {
          ...filters,
        },
        signal
      )
      if (response.status) {
        this.countryWiseProjectsTotal =
          (response.data?.organizationCountryCount || []).reduce(
            (acc, country) => {
              return acc + (country?.organizationCount || 0)
            },
            0
          ) || 0
        this.countryWiseProjects = response.data?.organizationCountryCount || []
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.countryWiseProjectsLoader = false
    }
  }

  @action.bound
  getCountryWiseProjectsFilters = () => {
    let temp = {}
    this.countryNameForProjects &&
      (temp['country'] = this.countryNameForProjects)
    return temp
  }

  @action.bound
  resetStore = () => {
    this.countryWiseProjects = []
    this.countryWiseProjectsLoader = false
    this.countryWiseProjectsTotal = 0
    this.countryNameForProjects = undefined
    this.currentCountryData = undefined
    this.currentSelecteCountry = undefined

    this.topOrgListData = []
    this.totalTopOrg = 0
    this.topOrgLoader = true
    this.topOrgFilters = {}

    this.ordering = undefined
    this.orderBy = undefined
  }
}
